import React from "react";
import Table from "../../components/table";
import { connect } from "react-redux";
import { loadingSelector, notificationsSelector } from "../../reducers";
import { fetchNotifications, fetchManagerAgents } from "actions";
import { Badge } from "react-bootstrap";
import { datetimezoneDisplay } from "../../utils";
import NotificationsFilterForm from "./NotificationsFilterForm";

const NotificationsPage = props => {
  React.useEffect(() => {
    document.title = "LifeRoc | Notifications";
    props.fetchManagerAgents();
  }, []);

  const columns = [
    {
      Header: "ID",
      accessor: "id",
    },
    {
      Header: "User",
      accessor: "user_name",
    },
    {
      Header: "Case ID",
      accessor: "case_id",
      Cell: ({ row }) => {
        if (row.original.case_id) {
          return (
            <div className="text-wrap">
              <a href={`/cases/${row.original.case_id}/files/`}>{row.original.case_submission_id}</a>
            </div>
          );
        } else {
          return "";
        }
      },
    },
    {
      Header: "Req. ID",
      accessor: "case_document_id",
      Cell: ({ row }) => {
        if (row.original.case_document_id) {
          return (
            <div className="text-wrap">
              <a href={`/cases/${row.original.case_id}/files/${row.original.case_document_id}/`}>
                {row.original.case_document_id}
              </a>
            </div>
          );
        } else {
          return "";
        }
      },
    },
    {
      Header: "Description",
      accessor: "type",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ row }) => {
        switch (row.original.status) {
          case 1:
            return <Badge variant="secondary">STARTED</Badge>;
          case 2:
            return <Badge variant="success">SUCCESS</Badge>;
          case 3:
            return <Badge variant="danger">FAILED</Badge>;
          case 4:
            return <Badge variant="danger">CANCELED</Badge>;
          default:
            return "";
        }
      },
    },
    {
      Header: "Create Time",
      accessor: "date_created",
      Cell: ({ row }) => {
        if (row.original.date_created) {
          return datetimezoneDisplay(row.original.date_created);
        } else {
          return "";
        }
      },
    },
    {
      Header: "Last Updated",
      accessor: "last_updated",
      Cell: ({ row }) => {
        if (row.original.last_updated && row.original.last_updated !== row.original.date_created) {
          return datetimezoneDisplay(row.original.last_updated);
        } else {
          return "";
        }
      },
    },
  ];

  return (
    <>
      <NotificationsFilterForm />
      <Table
        columns={columns}
        data={props.notifications}
        emptyMessage={props.loading.notifications ? "Loading Notifications data..." : "No data"}
        defaultSort={true}
        showPaginationResults={true}
        initialPageSize={100}
        defaultPagination={true}
      />
    </>
  );
};

const mapStateToProps = state => {
  return {
    notifications: notificationsSelector(state),
    loading: loadingSelector(state),
  };
};

export default connect(mapStateToProps, {
  fetchNotifications,
  fetchManagerAgents,
})(NotificationsPage);
